<template>
  
  <div class="flex flex-col py-2 gap-2 white w-full" :class="{'maincontent':!covMode}" style="overflow: auto;" >        
    <h3>{{$t('Simulation.ProcessingParameter')}}</h3>
    <div class="px-4">              
      <div class="flex gap-4 flex-wrap items-center">
        <v-text-field hide-details :label="`${$t('Simulation.MissionStartDate')} (UTC)`" type="datetime-local" v-model="startDate" />        
        <number-field-factor  hide-details v-model.number="modified.config.surfacing_time" :label="$t('Simulation.SurfacingTime')"  />        
        <v-switch  hide-details v-model="modified.config.enable_science_files" :label="$t('Simulation.EnableScienceFiles')"></v-switch>                        
      </div> 
      
      <div class="flex items-center gap-4" v-if="isCoverage">
          <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.ResolutionTime') }} :</div>
          <number-field-factor persistent-hint v-model.number="modified.config.resolution_time" :hint="$t('Simulation.ResolutionTimeHint')"  :min="1" :max="120" />
      </div>      
    </div>      
    <h3 class="mt-2">{{$t('Simulation.GliConfig')}}</h3>   
    <v-tabs style="height:100%;display:flex;flex-direction:column;" v-model="selectedGliderIdx" align-with-title >                      
        <!-- <v-tab v-for="(glider,idx) in modified.config.gliders_config" :key="idx" style="flex:0 0 auto" class="simulationdetailmore" :title="$t('Pilot.MissionInfos.AddDetailTabTooltip')" >
          {{ glider.libelle?glider.libelle
           :`Glider ${idx+1}` }}          
        </v-tab>  -->
        <v-tab v-for="(glider,idx) in modified.config.gliders_config" :key="idx"  @dblclick.native="editGliderTabName(idx)" 
              :title="editedGliderTabIdx == idx?`${glider.libelle?glider.libelle:`Glider ${idx+1}`} - ${$t('Pilot.MissionInfos.EscToCancel')}`:`${glider.libelle?glider.libelle:`Glider ${idx+1}`} - ${$t('Pilot.MissionInfos.DoubleClickToRename')}`" >        
          <template v-if="editedGliderTabIdx == idx">          
            <v-text-field style="margin-top:14px" autofocus @keyup.esc="cancelEditGliderName"  @keyup.enter="closeAndSaveGliderName" label="Glider Name" v-model="tmpGliderTabName"></v-text-field>
            <v-spacer />            
            <v-btn class="mr-0" small icon @click.prevent.stop="closeAndSaveGliderName" :title="$t('Pilot.MissionInfos.SaveTooltip')">
              <v-icon small>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <template v-else>
              {{ glider.libelle?glider.libelle:`Glider ${idx+1}` }}    
              <v-spacer />            
              <v-btn class="mr-0" small icon @click.prevent.stop="deleteGliderConfig(idx)" :title="$t('Pilot.MissionInfos.CloseDetailTabTooltip')">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
          </template>
        </v-tab>          
        <v-menu offset-y v-if="modified.config.gliders_config.length == 0 || (modified.MIG_TYP || 1) > 1" >
          <div slot="activator" class="cursor-pointer d-flex items-center justify-center px-3" v-ripple flat style="border-left:1px solid #eee;border-right:1px solid #eee;height:48px"><v-icon class="px-0">mdi-plus</v-icon></div>
          <v-list style="overflow: auto; max-height: 600px;">     
            <v-list-tile @click.prevent="addGliderConfig()">             
                <v-list-tile-title><strong>{{ $t('Simulation.AddGlider') }}</strong></v-list-tile-title>            
            </v-list-tile>            
              <!-- <v-list-tile>             
                <v-list-tile-title>{{  $t('Simulation.LoadGliderFromDb')  }}</v-list-tile-title>            
            </v-list-tile>    -->
          </v-list>  
        </v-menu>           
        <v-tab-item  v-for="(glider,idx) in modified.config.gliders_config" :reverse-transition="false" :transition="false" :key="idx">          
          <div class="flex flex-col gap-0 pa-2">
            <div class="flex items-end gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.GliderType') }} :</div>
              <v-select hide-details  :items="gliderTypes" item-text="libelle" item-value="value"  v-model="glider.glider_type"></v-select>
            </div> 
            <div class="flex items-end gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.BatteryType') }} :</div>
              <v-select hide-details  :items="batteryTypes" item-text="libelle" item-value="value"  v-model="glider.battery_type"></v-select>
            </div>
            <div class="flex items-end gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.BmsTypes') }} :</div>
              <v-select hide-details  :items="bmsTypes" item-text="libelle" item-value="value" v-model="glider.bms_type"></v-select>
            </div>
            <div class="flex items-end gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Admin.MissionPlanTemplate.Form.Sensors') }} :</div>
              <v-select                                
                v-model="glider.payload"
                :items="umbTypes"
                chips
                clearable     
                small-chips
                multiple
                hide-details
                deletable-chips
                @input="$store.myActions.SIMULATION_SYNC_MISSSIONPLAN_SENSOR()">
              </v-select>                
            </div>                  
            <div class="flex items-end gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.EnergyStart') }} :</div>      
              <number-field-factor hide-details v-model.number="glider.start_energy"  />
            </div>
            <div class="flex items-center gap-4">
              <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.EnergyEnd') }} :</div>      
              <number-field-factor v-model.number="glider.end_battery_percent"  :hint="$t('Simulation.EnergyEndHint')" persistent-hint :min="-1000" :max="100" />
            </div>         
            <div v-if="isCoverage || isFormation">
              <h4>{{$t('Admin.MissionPlanTemplate.Form.ScienceProfil')}}</h4>               
              <div class="flex items-center py-1 gap-4 sensor-row" v-for="sensor in glider.payload.map((s,idx) => ({id:idx+1,snr_label:s}))">                  
                <div style="min-width:100px;">{{ sensor.snr_label  }} :</div>
                <EditProfilSciRow v-if="currentEditProfilSci?.sensors?.[sensor.snr_label]" v-model="currentEditProfilSci.sensors[sensor.snr_label]" />
              </div>  
              <div  v-if="currentEditProfil">                
                <h4>{{$t('Admin.MissionPlanTemplate.Form.NavigationProfil')}}</h4>               
                <v-layout wrap>                                        
                <v-flex xs4 class="inline-block pa-2">                                  
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Bd')" :hint="$t('Admin.MissionPlanTemplate.Form.BdTooltip')" v-model.number="currentEditProfil.bd" />
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Bu')" :hint="$t('Admin.MissionPlanTemplate.Form.BuTooltip')" v-model.number="currentEditProfil.bu" />
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zs')" :hint="$t('Admin.MissionPlanTemplate.Form.ZsTooltip')" v-model.number="currentEditProfil.zs" />                
                </v-flex> 
                <v-flex xs4 class="inline-block pa-2">                  
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Pd')" :hint="$t('Admin.MissionPlanTemplate.Form.PdTooltip')" v-model.number="currentEditProfil.pd" />
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Pu')" :hint="$t('Admin.MissionPlanTemplate.Form.PuTooltip')" v-model.number="currentEditProfil.pu" />                                
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zt')" :hint="$t('Admin.MissionPlanTemplate.Form.ZtTooltip')" v-model.number="currentEditProfil.zt" />                                
                </v-flex>
                <v-flex xs4 class="inline-block pa-2">                  
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Sr')" :hint="$t('Admin.MissionPlanTemplate.Form.SrTooltip')" v-model.number="currentEditProfil.sr" />
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Alt')" :hint="$t('Admin.MissionPlanTemplate.Form.AltTooltip')" v-model.number="currentEditProfil.alt" />   
                  <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zb')" :hint="$t('Admin.MissionPlanTemplate.Form.ZbTooltip')" v-model.number="currentEditProfil.zb" />                                
                </v-flex>              
              </v-layout>
              <div class="d-flex flew-wrap items-center ">
                <v-switch hide-details v-model="currentEditProfil.radio" :label="$t('Simulation.Radio')"></v-switch>
                <v-switch hide-details v-model="currentEditProfil.flasher" :label="$t('Simulation.Flasher')"></v-switch>                                 
                <v-switch hide-details v-model="currentEditProfil.current_correction" :label="$t('Simulation.CurrentCorrection')"></v-switch>   
                <div class="d-flex items-center gap-2">
                  <span class="!grow-0">{{ $t("Simulation.NavigationMode") }}: </span>
                  <v-radio-group hide-details class="pa-0 ma-0" :column="false"  v-model="currentEditProfil.navigation_mode">                           
                    <v-radio hide-details value="heading" :label="$t('Pilot.MissionPlan.Heading')" />      
                    <v-radio hide-details value="waypoint" :label="$t('Pilot.MissionPlan.Waypoint')"  />        
                  </v-radio-group>                                             
                </div>
              </div>      
            </div>          
          </div>
        </div>                                   
        </v-tab-item>                        
    </v-tabs>  
    <v-layout v-if="!covMode" class="pt-0" row wrap style="flex:0 0;align-items:flex-start;" >
        <v-spacer />          
        <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>{{$t('Pilot.FtpRsync.RestoreConfig')}}<v-icon small right>mdi-replay</v-icon></v-btn>
        <v-btn @click.prevent="saveConfig" :disabled="!btnActif" :loading="saving" small color="primary">{{$t('Pilot.FtpRsync.ValidateConfig')}}<v-icon small right >mdi-content-save</v-icon></v-btn>
      </v-layout>                  
  </div>
</template>
<script lang="ts">


import Vue from 'vue'
import { ISmartSimulation, getDefaultSmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import LatLngMapField from '@/components/shared/field/LatLngMapField.vue'
import { IMissionPlanWaypoint } from '@/models/iris/missionPlan/IMissionPlanWaypoint'
import { getDefaultGliderConfig,IGliderConfig } from '@/models/iris/smartMission/IGliderConfig'
import { IGliderState } from '@/store/modules/glider/state'
import deepEqual from 'deep-equal' 
import { thresholdScott } from 'd3'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { isAloDbMissionGlobalCoverage, isAloDbMissionGlobalFormation, isAloDbMissionGlobalSimulation, isAloDbMissionGlobalSimulator } from '@/models/alodb/AloDbMissionGlobal'
import { getDefaultGliderCoverageConfig } from '@/models/iris/smartMission/IGliderCoverageConfig'
import EditProfilSciRow from '@/components/admin/missionPlanTemplate/EditProfilSciRow.vue'
import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
  
@Component({
  name: 'SimulationDetailParameter',
  components:{LatLngMapField,EditProfilSciRow},
  props: {
    covMode: {
      type:Boolean,
      default:false
    }
  } 
})
export default class SimulationDetailParameter extends Vue {      
    
  selectedGliderIdx = -1
  saving = false
  covMode!:boolean
  
  get coordFormatFilter(){
    return this.$store.myGetters.coordFormatFilter 
  }

  log(e:any)
  {
    console.log(e)
  }

  get isCoverage(){
    return isAloDbMissionGlobalCoverage(this.modified)
  }

  get isFormation(){
    return isAloDbMissionGlobalFormation(this.modified)
  }
  
  get gliderTypes(){
    return [
      {libelle:"SEAEXPLORER",value:'SEAEXPLORER'}     
    ]
  }

  get batteryTypes(){
    return [
      {libelle:"pack 18650",value:'pack 18650'},
      {libelle:"pack MP",value:'pack MP'},
      {libelle:"primary X2.1",value:'primary X2.1'},
      {libelle:"primary X2.1+pld",value:'primary X2.1+pld'},      
    ]
  }

  get bmsTypes(){
    return [
      {libelle:"tyva",value:'tyva'},
      {libelle:"neogy",value:'neogy'}
    ]
  }
  
  get modified(){
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get original(){
    return this.$store.myGetters.originalAdmMissionGlobal
  }

  get btnActif()  {
    return !deepEqual(this.modified,this.original) && !this.saving
  }

  get currentEditProfilSci(){
    if(isAloDbMissionGlobalCoverage(this.modified) || isAloDbMissionGlobalFormation(this.modified)){
      if(this.modified.config?.gliders_config[this.selectedGliderIdx] && !this.modified.config?.gliders_config[this.selectedGliderIdx]?.prf_sci?.length) {
        Vue.set(this.modified.config.gliders_config[this.selectedGliderIdx],"prf_sci", [{
              id:1,
              prf_label:"default",
              sensors:this.modified.config.gliders_config[this.selectedGliderIdx]?.payload?.reduce((s,p) => {s[p] = [1,"111",1]; return s},{} as {[key:string]:[number,string,number]})
        }])
      }
      return this.modified.config?.gliders_config[this.selectedGliderIdx]?.prf_sci?.at(0)
    }
    return null
  }

  get currentEditProfil(){
    if(isAloDbMissionGlobalCoverage(this.modified) ){
      if(this.modified.config?.gliders_config[this.selectedGliderIdx] && !this.modified.config?.gliders_config[this.selectedGliderIdx]?.prf_nav?.length){
        Vue.set(this.modified.config.gliders_config[this.selectedGliderIdx],"prf_nav",[{...MissionPlanUiState.getDefaultProfil(),id:1}])
      }
      return this.modified.config?.gliders_config[this.selectedGliderIdx]?.prf_nav?.at(0)
    }
    return null
  }

  get startDate() {
    return this.modified.config!.mission_start_date?.replace('Z','')
  }
  set startDate(value){    
    this.modified.config!.mission_start_date = value !=""?`${value}:00Z`:value    
  }

  // get lat_init(){    
  //   //@ts-ignore
  //   return this.modified.config.wpt_init?.at(0) ?? 0
  // }
  // set lat_init(value:number){
  //   this.modified.config!.wpt_init = [value,this.lng_init]
  // }

  // get lng_init(){
  //   //@ts-ignore
  //   return this.modified.config.wpt_init?.at(1) ?? 0
  // }
  // set lng_init(value:number){
  //   this.modified.config!.wpt_init = [this.lat_init,value]
  // }
  


  formatWaypoint(wpt:IMissionPlanWaypoint) {    
    return wpt.wpt_label&&wpt.wpt_label.length>0?wpt.wpt_label:this.toCoordString(wpt)
  }

  toCoordString(wpt:IMissionPlanWaypoint){
    //@ts-ignore    
    return this.$options.filters[this.$store.myGetters.coordFormatFilter]([wpt.wpt_lon,wpt.wpt_lat])
  }

  deleteGliderConfig(idx:number) {
    this.$confirm(this.$t('Admin.DeleteDialogMessage').toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {
          this.modified.config!.gliders_config.splice(idx,1)
        } 
      })   
  }


  editedGliderTabIdx = -1
  tmpGliderTabName = ""

  editGliderTabName(idx:number) {
    this.tmpGliderTabName = this.modified.config?.gliders_config[idx].libelle ?? `Glider ${idx+1}`
    this.editedGliderTabIdx = idx        
  }

  closeAndSaveGliderName() {
    this.modified.config!.gliders_config[this.editedGliderTabIdx].libelle = this.tmpGliderTabName    
    this.editedGliderTabIdx = -1
  }

  cancelEditGliderName() {                
    this.editedGliderTabIdx = -1
  }  

  addGliderConfig() {
    //Si on est en mode simulation on autorise qu'un seul glider sinon on autorise max 50 gliders    
    if((this.modified.config?.gliders_config?.length ?? 0) <  (this.modified.config?.processing_mode == "simulation"?1:50)) {
      if(isAloDbMissionGlobalSimulation(this.modified)) this.modified.config!.gliders_config.push(getDefaultGliderConfig())
      else if(isAloDbMissionGlobalCoverage(this.modified) || isAloDbMissionGlobalFormation(this.modified)) this.modified.config!.gliders_config.push(getDefaultGliderCoverageConfig())
      this.selectedGliderIdx = this.modified.config!.gliders_config.length-1
    }
  }
     
  
  get umbTypes(){
    //liste des capteurs sans le undefined
    return this.$store.myGetters.umbTypes.filter(s => s.UMT_ID != 1).map(it => it.UMT_KEY)
  }
  
  created() {  
    this.$store.myActions.UMBTYPE_ENSURE_LIST()
  }

  // nextSensorId(glider:IGliderConfig){
  //   return (this.missionPlan?.payload?.length ?? 0) > 0 ? (Math.max(...this.missionPlan.payload.map(i => i.id)) + 1):1
  // }

  get map_uiid() {
    return buildSimulationUIStateId(this.original.MIG_ID!,"map")
  }
 
  async saveConfig() {      
    this.saving = true    
    await this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST()
    this.saving = false    
    this.$store.myActions.UI_SELECT_MISSION_MAP({id:null,uiid:this.map_uiid})     
  }

  restoreConfig() {
    this.$store.myActions.MISSIONGLOBAL_CANCEL_MODIFIED_ADM()    
  }

}

</script> 